import { createRouter, createWebHashHistory } from 'vue-router'
import layout from '@/layout'
import permissionAdmin from './modules/permission/permissionAdmin'
import permissionRole from './modules/permission/permissionRole'
import permissionMark from './modules/permission/permissionMark'
// import AdminLog from './modules/other/AdminLog'

import authOrder from './modules/auth/authOrder'
import AdvanceFundIndex from './modules/advance_fund/index'
import CarAdvanceFundIndex from './modules/car_advance_fund/index'
import OtherAdvanceFundIndex from './modules/other_advance_fund/index'
import TeamAdvanceFundIndex from './modules/team_advance_fund/index'
// import PreSettleLableConfig from './modules/pre_settle_label_config/index'
// import PreSettleDictConfig from './modules/pre_settle_dict_config/index'
import marketingBirthday from './modules/marketing/birthday/index'
import CouponSendActivity from './modules/marketing/coupon_send_activity/index'
import Address from './modules/marketing/address/index'

import PreCloseIn1 from './modules/pre_close/in/index1'
import PreCloseIn2 from './modules/pre_close/in/index2'
import PreCloseIn3 from './modules/pre_close/in/index3'
import PreCloseIn4 from './modules/pre_close/in/index4'
import PreCloseIn5 from './modules/pre_close/in/index5'
import PreCloseIn6 from './modules/pre_close/in/index6'
import PreCloseIn7 from './modules/pre_close/in/index7'
import PreCloseIn8 from './modules/pre_close/in/index8'

import PreCloseOut1 from './modules/pre_close/out/index1'
import PreCloseOut2 from './modules/pre_close/out/index2'
import PreCloseOut3 from './modules/pre_close/out/index3'
import PreCloseOut4 from './modules/pre_close/out/index4'
import PreCloseOut5 from './modules/pre_close/out/index5'
import PreCloseOut6 from './modules/pre_close/out/index6'
import PreCloseOut7 from './modules/pre_close/out/index7'
import PreCloseOut8 from './modules/pre_close/out/index8'

// import FinCloseIn1 from './modules/fin_close/in/index1'
// import FinCloseIn2 from './modules/fin_close/in/index2'
// import FinCloseIn3 from './modules/fin_close/in/index3'
// import FinCloseIn4 from './modules/fin_close/in/index4'
// import FinCloseIn5 from './modules/fin_close/in/index5'
// import FinCloseIn6 from './modules/fin_close/in/index6'
// import FinCloseIn7 from './modules/fin_close/in/index7'

// import FinCloseOut1 from './modules/fin_close/out/index1'
// import FinCloseOut2 from './modules/fin_close/out/index2'
// import FinCloseOut3 from './modules/fin_close/out/index3'
// import FinCloseOut4 from './modules/fin_close/out/index4'
// import FinCloseOut5 from './modules/fin_close/out/index5'
// import FinCloseOut6 from './modules/fin_close/out/index6'
// import FinCloseOut7 from './modules/fin_close/out/index7'

import BossWorkPersonPerformance from './modules/person/performance/index'

// import Account from './modules/account/index'

import store from '@/store'

/**
 * 私有路由表 需要有权限才能访问
 */
export const privateRoutes = [
  authOrder,
  AdvanceFundIndex,
  CarAdvanceFundIndex,
  TeamAdvanceFundIndex,
  OtherAdvanceFundIndex,
  // Account,
  PreCloseIn1,
  PreCloseIn2,
  PreCloseIn3,
  PreCloseIn4,
  PreCloseIn5,
  PreCloseIn8,
  PreCloseIn6,
  PreCloseIn7,

  PreCloseOut1,
  PreCloseOut2,
  PreCloseOut3,
  PreCloseOut4,
  PreCloseOut5,
  PreCloseOut8,
  PreCloseOut6,
  PreCloseOut7,

  // FinCloseIn1,
  // FinCloseIn2,
  // FinCloseIn3,
  // FinCloseIn4,
  // FinCloseIn5,
  // FinCloseIn6,
  // FinCloseIn7,

  // FinCloseOut1,
  // FinCloseOut2,
  // FinCloseOut3,
  // FinCloseOut4,
  // FinCloseOut5,
  // FinCloseOut6,
  // FinCloseOut7,

  // PreSettleLableConfig,
  // PreSettleDictConfig,
  BossWorkPersonPerformance,

  marketingBirthday,
  Address,
  CouponSendActivity,
  // 管理员列表
  permissionAdmin,
  // 角色管理
  permissionRole,
  // 权限管理
  permissionMark
  // // 日志
  // AdminLog

]
/**
 * 公开路由表 不需要登录 就能访问的页面
 */
export const publicRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/index')
  },
  {
    path: '/bindWx',
    component: () => import('@/views/login/bindwx')
  },
  {
    path: '/',
    // 注意：带有路径“/”的记录中的组件“默认”是一个不返回 Promise 的函数
    component: layout,
    redirect: '/index',
    children: [
      // 个人中心
      {
        path: '/index',
        name: 'index',
        component: () => import('@/views/index/index'),
        meta: {
          title: 'profile',
          icon: 'el-icon-house'
        }
      },
      // 404 页面
      {
        path: '/404',
        name: '404',
        component: () => import('@/views/error_page/404')
      },
      // 401 页面
      {
        path: '/401',
        name: '401',
        component: () => import('@/views/error_page/401')
      }
    ]
  }
]

export function resetRouter () {
  if (
    store.getters.adminInfo &&
    store.getters.adminInfo.permission &&
    store.getters.adminInfo.permission.menus
  ) {
    const menus = store.getters.adminInfo.permission.menus

    menus.forEach((menu) => {
      router.removeRoute(menu)
    })
  }
}

const router = createRouter({
  history: createWebHashHistory(),
  routes: publicRoutes
})

export default router
